import { getChildComponents } from "@adobe/aem-react-editable-components"

// https://github.com/adobe/aem-react-editable-components/tree/master/src/components
export const CustomResponsiveGrid = (props) => {
  const children = getChildComponents(props.model)

  // Checking this because default layout has a responsive grid nested inside the root responsive grid that houses all components. If there is a 3rd level of nested responsive grid, that means we are using layout mode and need to handle rendering and apply classes from the model.json.

  // extend ResponsiveGrid component to support layout mode
  return (
    <div className={props.model.gridClassNames}>
      {children?.map((child, i) => (
        <div
          key={`${props.cqPath}-${props.model.cqItemsOrder[i]}`}
          className={props.model.columnClassNames[props.model.cqItemsOrder[i]]}
        >
          {child}
        </div>
      ))}
    </div>
  )
}
